
module.exports = require('./lib/index');



/*****************
 ** WEBPACK FOOTER
 ** ../~/results-hub-client/~/engine.io-client/index.js
 ** module id = 3040
 ** module chunks = 0
 **/